"use client";

import { useState } from "react";
import { Dialog, DialogContent, DialogTrigger, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Eye, ArrowUpRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const galleryItems = [{
  title: "Brand Strategy",
  category: "Creative",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/portfolio_brand_strategy.png",
  ratio: 4 / 3,
  description: "Developing a cohesive visual language and positioning for a global technology firm."
}, {
  title: "Digital Architecture",
  category: "Development",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/portfolio_digital_arch.png",
  ratio: 3 / 4,
  description: "Building high-performance, scalable web ecosystems with modern frameworks."
}, {
  title: "Visual Identity",
  category: "Design",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/portfolio_visual_id.png",
  ratio: 16 / 9,
  description: "Crafting iconic logos and typography systems that resonate with target audiences."
}, {
  title: "Motion Systems",
  category: "Animation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/portfolio_motion_design.png",
  ratio: 1,
  description: "Dynamic interface animations and cinematic brand reveals for digital platforms."
}, {
  title: "User Experience",
  category: "Interface",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/portfolio_ux_design.png",
  ratio: 3 / 4,
  description: "Intuitive flow design and prototype testing for enterprise-level SaaS applications."
}, {
  title: "Content Ecosystem",
  category: "Strategy",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/portfolio_content_strategy.png",
  ratio: 4 / 3,
  description: "Multi-channel content planning and execution to drive organic growth and engagement."
}, {
  title: "Technical Consulting",
  category: "Systems",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/portfolio_technical_consult.png",
  ratio: 16 / 9,
  description: "Optimizing cloud infrastructure and security protocols for financial services."
}, {
  title: "Product Innovation",
  category: "Development",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/portfolio_product_design.png",
  ratio: 1,
  description: "From concept to market: rapid prototyping and manufacturing oversight for hardware."
}, {
  title: "Market Integration",
  category: "Marketing",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/portfolio_market_launch.png",
  ratio: 4 / 3,
  description: "Strategic launch campaigns utilizing data-driven insights and social integration."
}];
export default function Gallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}